import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PayrollModuleMenuService } from '@app/modules/payroll/services/payroll-module-menu.service';
import { AuthService } from '@app/services';
import { WorkersCompensationTable } from '@payroll/services';
import { addYears, endOfDay, getYear, isAfter, isBefore, startOfDay } from 'date-fns';
import format from 'date-fns/format';

@Component({
    templateUrl: './workers-compensation-index.template.html',
})
export class WorkersCompensationIndexView {
    isLoading = false;

    table: WorkersCompensationTable;

    private readonly CURRENT_DATE = new Date();

    // Appears every year on November 1, and hides after December 31
    private readonly WARNING_BANNER = {
        START_DATE: startOfDay(new Date(getYear(this.CURRENT_DATE), 10, 1)),
        END_DATE: endOfDay(new Date(getYear(this.CURRENT_DATE), 11, 31)),
    };

    constructor(
        public router: Router,
        public route: ActivatedRoute,
        public auth: AuthService,
        public payrollModuleMenuService: PayrollModuleMenuService
    ) {
        this.table = new WorkersCompensationTable(this.auth);

        this.table.links = this.route.snapshot.data.isPayrollPending ? false : true;
        this.table.showMenuColumnOptions = this.route.snapshot.data.isPayrollPending ? false : true;
    }

    get shouldShowYearEndWarning(): boolean {
        return (
            isAfter(this.CURRENT_DATE, this.WARNING_BANNER.START_DATE) &&
            isBefore(this.CURRENT_DATE, this.WARNING_BANNER.END_DATE)
        );
    }

    get formattedYearEndDate(): string {
        return format(this.WARNING_BANNER.END_DATE, 'MMMM D, YYYY');
    }

    get formattedNextYear(): string {
        return format(addYears(this.CURRENT_DATE, 1), 'YYYY');
    }
}
